import apiClient from '@utils/apiClient';
import {
    WeatherStationListReq,
    WeatherStationListRes,
} from '@/api/weather/station/type';
import { ApiResult } from '@/api/common/type';

export const api = {
    /**
     * 기상대목록
     * @param param
     */
    weatherStationList: async (
        param: WeatherStationListReq,
    ): Promise<WeatherStationListRes> => {
        const response = await apiClient.post<WeatherStationListRes>(
            '/api/v1/weather/station/list',
            param,
        );
        return response.data;
    },

    /**
     * 기상대갱신
     */
    refreshWeatherStationList: async (): Promise<ApiResult> => {
        const response = await apiClient.get<ApiResult>(
            '/api/v1/weather/station/refresh',
        );
        return response.data;
    },
};
